import React, { Component } from 'react';
import { CircularProgress } from 'material-ui';
import stackOfCoins from '../../../images/stack-of-coins.png';
import api from '../../../lib/api';

import {
  GetMoreLeadsContainer,
  GetLeadsButtonContainer,
  GetMoreLeadsButton,
  StackOfCoingImg,
  MoreLeadsMessage,
  ErrorReasonText
} from './styles';

class GetMoreLeads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: false,
      errorMessage: '',
      moreLeadsEnabled: false
    };
  }

  async componentDidMount() {
    try {
      await api.validateRequestLead();
      this.setState({ loading: false, enableMoreLead: true });
    } catch (error) {
      this.setState({
        loading: false,
        error: true,
        errorMessage:
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Please try again'
      });
    }
  }

  onGetMoreLeadsClick = async () => {
    this.setState({ loading: true });
    try {
      await api.assignMoreLeads();
      this.setState({
        loading: false,
        moreLeadsEnabled: true
      });
    } catch (error) {
      this.setState({
        loading: false,
        error: true,
        errorMessage:
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Please try again'
      });
    }
  };

  renderButton = () => {
    const { moreLeadsEnabled, error } = this.state;
    return (
      <GetMoreLeadsButton
        onClick={() => this.onGetMoreLeadsClick()}
        disabled={moreLeadsEnabled || error}
      >
        GET MORE LEADS <StackOfCoingImg src={stackOfCoins} alt="" />
      </GetMoreLeadsButton>
    );
  };

  render() {
    const { loading, error, moreLeadsEnabled, errorMessage } = this.state;

    if (loading) {
      return (
        <GetMoreLeadsContainer>
          <GetLeadsButtonContainer>
            <CircularProgress size={20} thickness={5} color="primary" />
          </GetLeadsButtonContainer>
        </GetMoreLeadsContainer>
      );
    }

    return (
      <GetMoreLeadsContainer>
        <GetLeadsButtonContainer>
          {this.renderButton()}
          {moreLeadsEnabled && (
            <MoreLeadsMessage>
              Request is in a queue, leads will be assigned in few miniutes
            </MoreLeadsMessage>
          )}
          {error && <ErrorReasonText>{errorMessage}</ErrorReasonText>}
        </GetLeadsButtonContainer>
      </GetMoreLeadsContainer>
    );
  }
}

export default GetMoreLeads;



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GetMoreLeads/index.js